export function useValidation() {
    const getValidationKey = (key: string): string => {
        return `validation.${key}`;
    };

    return {
        getValidationKey
    };
}
